import { IconPlus, IconUpload, IconUserPlus } from '@tabler/icons-react';
import { Button } from '@zorro/design-system/v2/Button';
import { Menu } from '@zorro/design-system/v2/Menu';

import { useAnalytics } from '../Analytics';
import { EmployeeActionsOverlays } from '../EmployeeActions';

type EmployeeManagementActionsMenuProps = {
  setOverlayId: (id: EmployeeActionsOverlays) => void;
  isDisabled?: boolean;
};

export function EmployeeManagementActionsMenu({
  setOverlayId,
  isDisabled = false,
}: EmployeeManagementActionsMenuProps) {
  const { sendEvent } = useAnalytics();

  return (
    <Menu size="sm" disabled={isDisabled}>
      <Menu.Target>
        <Button
          disabled={isDisabled}
          variant="primary"
          size="xs"
          leftSection={<IconPlus />}
          aria-label="Add employee"
        />
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={() => {
            void sendEvent('click_add_employee', {
              adding_method: 'upload_roster',
            });
            setOverlayId(EmployeeActionsOverlays.UPLOAD_ROSTER);
          }}
          leftSection={<IconUpload size={16} stroke={1.25} />}
          disabled={isDisabled}
        >
          Upload roster
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            void sendEvent('click_add_employee', {
              adding_method: 'add_a_new_employee',
            });
            setOverlayId(EmployeeActionsOverlays.ADD_EMPLOYEE);
          }}
          leftSection={<IconUserPlus size={16} stroke={1.25} />}
          disabled={isDisabled}
        >
          Add a new employee
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
